var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'model/base'], function($, core, BaseModel) {
  var LedgerAccountCategoryModel;
  return LedgerAccountCategoryModel = (function(_super) {

    __extends(LedgerAccountCategoryModel, _super);

    function LedgerAccountCategoryModel() {
      LedgerAccountCategoryModel.__super__.constructor.apply(this, arguments);
    }

    LedgerAccountCategoryModel.prototype.pathRoot = core.getConfig().apiPrefix + 'ledgeraccountcategory.json';

    LedgerAccountCategoryModel.prototype.defaults = function() {
      return {
        id: null,
        name: ''
      };
    };

    return LedgerAccountCategoryModel;

  })(BaseModel);
});
